const campusApi = {
  GETCAMPUSLISTBYPAGER: 'CSVPA-China/api/campus/getListByPager', //学习中心列表
  SAVECAMPUS: 'CSVPA-China/api/campus/save', //新增学习中心
  UPDATECAMPUS: 'CSVPA-China/api/campus/update', //编辑学习中心
  DELETECAMPUS: 'CSVPA-China/api/campus/delete', //删除学习中心
  GETLISTALLCAMPUS: 'CSVPA-China/api/campus/getListAll', //所有学习中心
  TEACHINGCOURSE: 'CSVPA-China/api/teaching-course/page', //获取所有教师学科配置
  SELECTCAMPUS: 'CSVPA-China/api/campus/getListAll'
}

export default campusApi
